import React from 'react';
import { Link } from 'react-router-dom';

// Retain the old return URL for existing bookmarks without treating it as
// payment evidence or requiring a paid plan for free learning.
export default function CheckoutSuccess() {
  return <main className="min-h-screen bg-slate-950 flex items-center justify-center p-6">
    <section className="max-w-lg rounded-2xl border border-slate-700 bg-slate-900 p-8 text-white">
      <h1 className="text-2xl font-bold mb-4">Tekyu learning is free</h1>
      <p className="text-slate-300 mb-6">Explore career roadmaps and project guides. Sign in to your free Tekyu account to save your work.</p>
      <Link to="/portal" className="block rounded-lg bg-green-500 text-slate-950 p-3 font-semibold text-center">Open your Tekyu workspace</Link>
      <Link to="/roles" className="block mt-4 text-green-400">Explore free career paths</Link>
      <h2 className="mt-8 font-semibold">Returning from an earlier payment?</h2>
      <p className="mt-2 text-sm text-slate-300">This page does not confirm a payment or cancel an existing subscription. You do not need another payment to use Tekyu. Contact billing support with your receipt if you need help with a previous charge.</p>
      <a href="mailto:support@tekyu.co.uk?subject=Tekyu%20previous%20subscription" className="block mt-3 text-green-400">Contact Tekyu billing support</a>
      <h2 className="mt-8 font-semibold">Already enrolled with Cyber Agoge?</h2>
      <p className="mt-2 text-sm text-slate-300">The paid bootcamp uses a separate student portal. Use your existing Cyber Agoge account for lessons and support.</p>
      <a href="https://portal.cyberagoge.com/" className="block mt-3 text-green-400">Open the Cyber Agoge student portal</a>
    </section>
  </main>;
}
